import React from 'react';
import classNames from 'classnames';
import WasteIcon from '../WasteIcon';
import { formatDate } from '../../helpers/date';
import ListItem from '../ListItem';
import { WASTE_STREAM_REST, WASTE_STREAM_GFT, WASTE_STREAM_PMD, WASTE_STREAM_PAPER, WASTE_STREAM_GLAS, WASTE_STREAM_TEXTILE } from '../../config/constants';
const WasteStreamTeaser = props => {
  const {
    date,
    wasteStreamId,
    href,
    title,
    descriptionId,
    onClick
  } = props;
  const classes = classNames('WasteStreamTeaser', {
    'WasteStreamTeaser--rest': wasteStreamId === WASTE_STREAM_REST,
    'WasteStreamTeaser--gft': wasteStreamId === WASTE_STREAM_GFT,
    'WasteStreamTeaser--pmd': wasteStreamId === WASTE_STREAM_PMD,
    'WasteStreamTeaser--paper': wasteStreamId === WASTE_STREAM_PAPER,
    'WasteStreamTeaser--glass': wasteStreamId === WASTE_STREAM_GLAS,
    'WasteStreamTeaser--textile': wasteStreamId === WASTE_STREAM_TEXTILE
  });
  return /*#__PURE__*/React.createElement(ListItem, {
    title: formatDate(date),
    subtitle: title,
    icon: /*#__PURE__*/React.createElement(WasteIcon, {
      streamId: wasteStreamId
    }),
    link: href,
    className: classes,
    descriptionId: descriptionId,
    onClick: onClick
  });
};
export default WasteStreamTeaser;